import React from 'react';
import Container from './Container';
import { Default, Mobile } from '../../Sizes';
import Presenter from './Presenter';
import MobilePresenter from './MobilePresenter';

function DurationPicker(props){
	return (
		<Container 
			{...props}
			render={(containerProps, other)=>(
				<React.Fragment>
					<Default>
						<Presenter 
							{...containerProps}
							{...other}/>
					</Default>
					<Mobile>
						<MobilePresenter 
							{...containerProps}
							{...other}
						/>
					</Mobile>
				</React.Fragment>
				
			)}
		/>
	);
}

export default DurationPicker;

